import {
  CustomerMapParsed,
  MatchboiError,
  SupportedTools,
} from '../interfaces';
import { DefaultTool, Tool } from './base';
import { CarbonBlackResponseTool } from './carbonblack-response.tool';
import { CarbonBlackCloudInvestigateTool } from './carbonblackcloud-investigate.tool';
import { CorelightInvestigatorTool } from './corelight-investigator';
import { CrowdStrikeLogScaleTool } from './crowdstrike-logscale.tool';
import { CrowdStrikeTool } from './crowdstrike.tool';
import { ElasticTool } from './elastic.tool';
import { GoogleSecOpsTool } from './google-secops';
import { MicrosoftDefenderTool } from './microsoft-defender.tool';
import { MicrosoftSentinelTool } from './microsoft-sentinel.tool';
import { PaloAltoCortexXDRTool } from './paloalto-cortex-xdr.tool';
import { QRadarTool } from './qradar.tool';
import { SentinelOneTool } from './sentinelone.tool';
import { SentinelOneSingularityTool } from './sentinelone-singularity.tool';
import { SplunkTool } from './splunk.tool';
import { TaniumTool } from './tanium.tool';
import { TrendMicroVisionOneTool } from './trendmicro-visionone.tool';

export { Tool };

// TODO: auto discover from local recursive directory search for Tool subclasses
const allToolsList: Array<new () => Tool> = [
  SplunkTool,
  ElasticTool,
  CrowdStrikeTool,
  CrowdStrikeLogScaleTool,
  CarbonBlackResponseTool,
  CarbonBlackCloudInvestigateTool,
  CorelightInvestigatorTool,
  MicrosoftDefenderTool,
  MicrosoftSentinelTool,
  QRadarTool,
  SentinelOneTool,
  SentinelOneSingularityTool,
  TrendMicroVisionOneTool,
  PaloAltoCortexXDRTool,
  TaniumTool,
  GoogleSecOpsTool,
].sort((a, b) => a.name.localeCompare(b.name));

/* Tool mapping by name to respective Tool instance*/
export const toolsMap: {
  [key in SupportedTools]?: Tool;
} = Object.fromEntries(
  allToolsList.map((toolClass) => {
    const tool = new toolClass();
    return [tool.toolName, tool];
  }),
);

/**
 * Get instance of tool by name, defaulting to base Tool when not available
 * @param toolName Target tool name
 */
export const toolFactory = (toolName: SupportedTools): Tool => {
  return toolsMap[toolName] ?? new DefaultTool();
};

/**
 * Parse exported tool field mapping into the common parsed map format, or throws error if not supported
 *
 * @param toolExportContents Contents from the tool field mapping export
 * @param toolName Select which tool the export came from to use the appropriate parser
 */
export const processMapUpload = (
  toolExportContents: string,
  toolName: SupportedTools,
): CustomerMapParsed => {
  const tool = toolFactory(toolName);

  if (!tool.supportsMapUploads())
    throw new MatchboiError(`Tool "${toolName}" does not support map uploads`);

  return tool.parseMapUpload(toolExportContents);
};
